// GENERATE BY ./scripts/generate.ts
// DON NOT EDIT IT MANUALLY
import * as React from 'react';
import BellOutlinedSvg from "@ant-design/icons-svg/es/asn/BellOutlined";
import AntdIcon from '../components/AntdIcon';

var BellOutlined = function BellOutlined(props, ref) {
  return React.createElement(AntdIcon, Object.assign({}, props, {
    ref: ref,
    icon: BellOutlinedSvg
  }));
};

BellOutlined.displayName = 'BellOutlined';
export default React.forwardRef(BellOutlined);


//////////////////
// WEBPACK FOOTER
// ./node_modules/_@ant-design_icons@4.0.6@@ant-design/icons/es/icons/BellOutlined.js
// module id = 639
// module chunks = 0